import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { BaseResolver } from '../base.resolver';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    data: {
      title: 't.venio.login',
    },
    resolve: {
      resolver: BaseResolver,
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
